import { type ReactNode } from 'react';
import type { Approacher } from '../types';
import { ApproacherProfile } from './approacher-profile';
import { ApproacherFields } from './approacher-fields';
import { DetailFooter, type FooterProps } from './detail-footer';

export type DetailMode =
  | 'view'
  | 'archive'
  | 'restore'
  | 'reset-confirm'
  | 'reset-reveal'
  | 'streak-reset-confirm'
  | 'photo-upload'
  | 'vacation'
  | 'status-edit';

type Props = FooterProps & { onStatusEdit: () => void };

const SECTION_DIVIDER = 'border-t border-white/[0.06] pt-base';

function hasInfo(a: Approacher): boolean {
  return !!(
    a.email ||
    a.phone ||
    a.city ||
    a.country ||
    a.birthdate ||
    a.usdc_wallet ||
    a.manychat_subscriber_id
  );
}

function InfoSection({ a }: { a: Approacher }): ReactNode {
  if (!hasInfo(a)) return null;
  return (
    <div className={SECTION_DIVIDER}>
      <ApproacherFields a={a} />
    </div>
  );
}

export function DetailView(p: Props): ReactNode {
  return (
    <div className="space-y-base">
      <ApproacherProfile a={p.a} onStatusEdit={p.onStatusEdit} />
      <InfoSection a={p.a} />
      <DetailFooter {...p} />
    </div>
  );
}
